import { render, staticRenderFns } from "./StaffManage.vue?vue&type=template&id=7de9f4d8&scoped=true&"
import script from "./StaffManage.vue?vue&type=script&lang=js&"
export * from "./StaffManage.vue?vue&type=script&lang=js&"
import style0 from "./StaffManage.vue?vue&type=style&index=0&id=7de9f4d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de9f4d8",
  null
  
)

export default component.exports